import axios from 'axios'


const configuredAxios = axios.create({baseURL: "https://backend." + window.location.host})
export default configuredAxios;
